import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { SectionSubtitle, SectionTitle } from "../../SectionTitleElements";
import {
  ButtonEmail,
  ContactButton,
  ContactButtonIcon,
  ContactCard,
  ContactCardData,
  ContactCardIcon,
  ContactCardTitle,
  ContactContainer,
  ContactForm,
  ContactFormArea,
  ContactFormDiv,
  ContactFormInput,
  ContactFormTag,
  ContactInfo,
  ContactSection,
  ContactTextArea,
  ContactTitle,
} from "./ContactElements";

const Contact = ({ darkMode }) => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);
  const emailServiceId = process.env.REACT_APP_EMAIL_SERVICE_ID;
  const emailTemplateId = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
  const emailUserId = process.env.REACT_APP_EMAIL_USER_ID;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const name = e.target.elements.from_name.value;
    const email = e.target.elements.from_email.value;
    const message = e.target.elements.message.value;

    if (!name || !email || !message) {
      toast.error("Please fill in all fields.");
      return;
    }

    const currentDate = new Date().toISOString().split("T")[0];
    const sentCount = parseInt(localStorage.getItem(`sentCount_${email}`)) || 0;
    const lastSentDate = localStorage.getItem(`lastSentDate_${email}`);

    if (lastSentDate === currentDate && sentCount >= 3) {
      toast.error("You have reached the email sending limit for today.");
      return;
    }

    setIsSending(true);

    emailjs
      .sendForm(emailServiceId, emailTemplateId, e.target, emailUserId)
      .then(
        (result) => {
          console.log(result.text);
          setIsSending(false);
          toast.success("Email sent!👍");

          localStorage.setItem(`sentCount_${email}`, sentCount + 1);
          localStorage.setItem(`lastSentDate_${email}`, currentDate);

          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          setIsSending(false);
          toast.error("Error, please try again!");
        }
      );
  };

  return (
    <ContactSection id="contact">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <SectionSubtitle>Don't be shy! Hit me up! 👇</SectionSubtitle>
        <SectionTitle>Contact Me</SectionTitle>

        <ContactContainer>
          <motion.div className="contact_content" variants={itemVariants}>
            <ContactTitle light={darkMode ? 1 : 0}>Get in touch</ContactTitle>

            <ContactInfo>
              <motion.div variants={itemVariants}>
                <ContactCard light={darkMode ? 1 : 0}>
                  <ContactCardIcon light={darkMode ? 1 : 0}>
                    <i className="bx bxl-gmail"></i>
                  </ContactCardIcon>
                  <ContactCardTitle light={darkMode ? 1 : 0}>
                    Email
                  </ContactCardTitle>
                  <ContactCardData light={darkMode ? 1 : 0}>
                    rojanacharya404@gmail.com
                  </ContactCardData>
                  <ContactButton
                    href="mailto:rojanacharya404@gmail.com"
                    target={"_blank"}
                  >
                    Write a mail
                    <ContactButtonIcon>
                      <i className="bx bx-right-arrow-alt"></i>
                    </ContactButtonIcon>
                  </ContactButton>
                </ContactCard>
              </motion.div>

              <motion.div variants={itemVariants}>
                <ContactCard light={darkMode ? 1 : 0}>
                  <ContactCardIcon light={darkMode ? 1 : 0}>
                    <i className="bx bxl-twitter"></i>
                  </ContactCardIcon>
                  <ContactCardTitle light={darkMode ? 1 : 0}>
                    Twitter
                  </ContactCardTitle>
                  <ContactCardData light={darkMode ? 1 : 0}>
                    @rojan010
                  </ContactCardData>
                  <ContactButton
                    href="https://x.com/rojanacharya"
                    target={"_blank"}
                  >
                    Write me
                    <ContactButtonIcon>
                      <i className="bx bx-right-arrow-alt"></i>
                    </ContactButtonIcon>
                  </ContactButton>
                </ContactCard>
              </motion.div>
            </ContactInfo>
          </motion.div>

          <motion.div variants={itemVariants}>
            <ContactTitle light={darkMode ? 1 : 0}>
              Write me your project
            </ContactTitle>

            <ContactForm ref={form} onSubmit={sendEmail}>
              <ContactFormDiv>
                <ContactFormTag htmlFor="" light={darkMode ? 1 : 0}>
                  Your Name
                </ContactFormTag>
                <ContactFormInput
                  light={darkMode ? 1 : 0}
                  type="text"
                  name="from_name"
                  placeholder="Enter your name"
                  required
                />
              </ContactFormDiv>

              <ContactFormDiv>
                <ContactFormTag htmlFor="" light={darkMode ? 1 : 0}>
                  Email
                </ContactFormTag>
                <ContactFormInput
                  light={darkMode ? 1 : 0}
                  type="email"
                  name="from_email"
                  placeholder="Enter your email"
                  required
                />
              </ContactFormDiv>

              <ContactFormArea>
                <ContactFormTag htmlFor="" light={darkMode ? 1 : 0}>
                  Project
                </ContactFormTag>
                <ContactTextArea
                  name="message"
                  required
                  cols="30"
                  rows="10"
                  placeholder="Tell me about your project..."
                  light={darkMode ? 1 : 0}
                />
              </ContactFormArea>

              <ButtonEmail
                type="submit"
                value="send"
                disabled={isSending}
                className="group"
              >
                {isSending ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Sending...
                  </>
                ) : (
                  <>
                    Send Message
                    <i className="bx bx-send ml-2 group-hover:translate-x-1 transition-transform"></i>
                  </>
                )}
              </ButtonEmail>
            </ContactForm>
          </motion.div>
        </ContactContainer>
      </motion.div>
    </ContactSection>
  );
};

export default Contact;
